module.exports = __webpack_public_path__ + "static/1-5454d5693ecfbfbbac4b7d1fdbbc0e5f.png";